import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Injectable } from '@angular/core';
import { FinishProService } from "./finish-pro.service";
import { LoadingProService } from "./loading-pro.service";
import { BrandingService } from "./branding.service";

@Injectable({
  providedIn: "root"
})

export class OperationGuardService implements CanActivate {

  constructor(
    private readonly loaderService: LoadingProService,
    private readonly finishProService: FinishProService,
    public loadingPro: LoadingProService,
    private readonly brandingService: BrandingService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      if (!this.finishProService.hasNextOperation) {
        this.loaderService.setLoader(true);
      }

      if (route.params["id"]?.includes("?token")) {
        const operationId = route.params["id"].split("?")[0];
        this.finishProService.setOperationID(operationId);
      } else if (route.queryParams["token"]) {
        this.finishProService.tokenSAML = route.queryParams["token"];
        this.finishProService.setOperationID(route.params["id"]);
      } else {
        this.finishProService.setOperationID(route.params["id"]);
      }
      const response = await this.finishProService.isNextOperationClosed();
      if (response) {
        this.brandingService.generateBranding();
        return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }
}
